import type { VisualizationType } from '@tempo-io/roadmap-dto';

const VISUALIZATION_KEY = 'nexus_roadmap_last_visited_visualization';
const VIEW_KEY = 'nexus_roadmap_last_visited_view';

type VisualizationStorage = Partial<Record<number, VisualizationType>>;
type ViewStorage = Partial<Record<number, number>>;

function read<T>(key: string): T extends object ? T : never {
  try {
    const raw = window.localStorage.getItem(key);
    return (raw ? JSON.parse(raw) : {}) as T extends object ? T : never;
  } catch {
    return {} as T extends object ? T : never;
  }
}

function write(key: string, data: object): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(data));
  } catch {
    // localStorage disabled or quota exceeded — silently ignore
  }
}

export function getLastVisitedVisualization(viewId: number): VisualizationType | undefined {
  if (typeof window === 'undefined') return undefined;
  return read<VisualizationStorage>(VISUALIZATION_KEY)[viewId];
}

export function saveLastVisitedVisualization(viewId: number, type: VisualizationType): void {
  if (typeof window === 'undefined') return;
  write(VISUALIZATION_KEY, { ...read<VisualizationStorage>(VISUALIZATION_KEY), [viewId]: type });
}

export function getLastVisitedView(roadmapId: number): number | undefined {
  if (typeof window === 'undefined') return undefined;
  return read<ViewStorage>(VIEW_KEY)[roadmapId];
}

export function saveLastVisitedView(roadmapId: number, viewId: number): void {
  if (typeof window === 'undefined') return;
  write(VIEW_KEY, { ...read<ViewStorage>(VIEW_KEY), [roadmapId]: viewId });
}
